"use client";

import {
	Pagination,
	PaginationContent,
	PaginationItem,
	PaginationNext,
	PaginationPrevious,
} from "@/components/ui/pagination";
import { usePathname, useSearchParams } from "next/navigation";

export const ProductsPagination = ({
	pagination,
}: { pagination: null | { page: number; hasNextPage: boolean; hasPrevPage: boolean } }) => {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	if (!pagination) {
		return null;
	}
	if (!pagination.hasNextPage && !pagination.hasPrevPage) {
		return null;
	}

	const newSearchParams = new URLSearchParams(searchParams);

	newSearchParams.set("page", String(pagination.page - 1));
	const prevPageHref = `${pathname}?${newSearchParams.toString()}`;

	newSearchParams.set("page", String(pagination.page + 1));
	const nextPageHref = `${pathname}?${newSearchParams.toString()}`;

	return (
		<Pagination className="justify-end items-center border-t gap-4 py-2 pl-4 pr-2">
			<PaginationContent>
				{/* <p className="text-sm mr-auto">
				{t("items.itemsOf", {
					start: (page - 1) * perPage + 1,
					end: Math.min(count, page * perPage),
					count,
				})}
			</p>
			<p className="text-sm">{t("pageOf", { page, lastPage })}</p> */}

				<PaginationItem>
					<PaginationPrevious
						href={prevPageHref}
						aria-disabled={!pagination.hasPrevPage}
						className="aria-disabled:opacity-40 aria-disabled:pointer-events-none"
					/>
				</PaginationItem>
				<PaginationItem>
					<PaginationNext
						href={nextPageHref}
						aria-disabled={!pagination.hasNextPage}
						className="aria-disabled:opacity-40 aria-disabled:pointer-events-none"
					/>
				</PaginationItem>
			</PaginationContent>
		</Pagination>
	);
};
